import DOMPurify from 'dompurify';

const getMessageSnippet = (message, limit = 110) => {
  if (!message) {
    return undefined;
  }
  let decoded = message;
  try {
    decoded = decodeURIComponent(message);
  } catch (e) {}
  const snippet = DOMPurify.sanitize(
    String(decoded || '')
      .replace(/\\n/g, ' ')
      .replace(/<br>/g, ' ')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/<\/?(pre|p|span)>/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' On ')[0]
  );
  if (!snippet) {
    return undefined;
  }
  const trimmedSnippet = snippet.length < limit ? snippet : `${snippet.slice(0, limit)}...`;
  return ['.', '!', '?', '>', '<'].includes(trimmedSnippet[trimmedSnippet.length - 1]) ? trimmedSnippet : `${trimmedSnippet}.`;
};

export default getMessageSnippet;
